/* istanbul ignore file */
/* tslint:disable */
 

/**
 * * `cash` - Cash
 * * `cash_mia` - Cash Mia
 * * `pos` - Pos
 * * `bank_transfer` - Bank Transfer
 * * `credit` - Internal credit
 * * `broker_settlement` - Broker Settlement
 */
export enum PaymentTypeStaffBroker {
  CASH = 'cash',
  CASH_MIA = 'cash_mia',
  POS = 'pos',
  BANK_TRANSFER = 'bank_transfer',
  CREDIT = 'credit',
  BROKER_SETTLEMENT = 'broker_settlement',
}
